import Reflux from "reflux";
import UIActions from "@/actions/UIActions";

const RightClickMenuStore = Reflux.createStore({
  listenables: [UIActions],

  init() {
    this.menuState = null;
  },

  /**
   * Sets the state of the right-click context menu.
   * @param {Object} menuState - The new menu state to set.
   * @listens UIActions.setRightClickMenuState
   */
  onSetRightClickMenuState(menuState) {
    this.menuState = menuState;
    this.trigger(this.menuState);
  },

  /**
   * Closes the right-click context menu.
   * @listens UIActions.closeRightClickMenu
   */
  onCloseRightClickMenu() {
    this.menuState = null;
    this.trigger(this.menuState);
  },

  /**
   * Automatically closes the right-click menu when an element is selected.
   * This handles cases where element clicks have stopPropagation() that prevents
   * the click-outside detection from working.
   * @listens UIActions.selectElement
   */
  onSelectElement() {
    if (this.menuState) {
      this.menuState = null;
      this.trigger(this.menuState);
    }
  },

  /**
   * Automatically closes the right-click menu when a block is selected.
   * @listens UIActions.selectBlock
   */
  onSelectBlock() {
    if (this.menuState) {
      this.menuState = null;
      this.trigger(this.menuState);
    }
  },

  /**
   * Automatically closes the right-click menu when elements are cleared.
   * @listens UIActions.clearSelectedElements
   */
  onClearSelectedElements() {
    if (this.menuState) {
      this.menuState = null;
      this.trigger(this.menuState);
    }
  },

  /**
   * Returns the current state of the right-click context menu.
   * @returns {Object|null} The current menu state or null if no menu is open.
   */
  getRightClickMenuState() {
    return this.menuState;
  },
});

export default RightClickMenuStore;
